import { faqs, featuredStories, categories } from '@/mocks/homeData';

const siteUrl = 'https://bengtingb.cn/';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '美日吃瓜',
    alternateName: '美日社会奇闻频道',
    url: siteUrl,
    inLanguage: 'zh-CN',
    description:
      '汇集美日两国社会奇闻与奇葩事件，离奇案件、迷惑行为、都市怪谈、民间传说持续收录。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '美日吃瓜',
    url: siteUrl,
    email: 'hello@meirichigua.com',
    description: '专注美国与日本社会奇闻、离奇案件与都市怪谈的中文内容频道。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '本周热门推荐',
    itemListElement: featuredStories.map((story, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: story.title,
      description: story.excerpt,
    })),
  },
  {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: '主题分类',
    itemListElement: categories.map((cat, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: cat.name,
      description: cat.desc,
    })),
  },
];

export default function StructuredData() {
  return (
    <>
      {jsonLd.map((block, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(block) }}
        />
      ))}
    </>
  );
}